import { Provider, useAtomValue } from 'jotai'
import { AnimatePresence } from 'framer-motion'

import { StandardLayout } from '@sequencehq/core-components'

import { manualTaskProcessorTaskIdAtom } from 'Automations/watchtower/atoms'
import { ManualTaskProcessor } from 'Automations/watchtower/inbox/manualTasks/manualTasksProcessor/root.modal'
import { usePopulateResolvedNodeDefinitions } from 'Automations/nodeDefinitions'
import { InboxPanes } from 'Automations/components/InboxPanes'
import { useCurrentListView } from './hooks/useCurrentListView'
import { TasksList } from './components/TasksList'
import { TaskPreview } from './components/TaskPreview'

// The routes that mean a task is open, so mobile shows its detail rather than
// the list. Both tabs route tasks and notifications separately.
const DETAIL_ROUTE_PATTERNS = [
  '/watchtower/inbox/tasks/:taskId',
  '/watchtower/inbox/notifications/:notificationId',
  '/watchtower/inbox/all/tasks/:taskId',
  '/watchtower/inbox/all/notifications/:notificationId'
]

export const Inbox = () => {
  return (
    <Provider>
      <InboxContent />
    </Provider>
  )
}

const InboxContent = () => {
  const { currentView } = useCurrentListView()
  const processorTaskId = useAtomValue(manualTaskProcessorTaskIdAtom)

  // Resolve node definitions once into the watchtower's atom so execution
  // summaries can read concrete definitions (incl. the async start nodes)
  // synchronously, mirroring the editor's load.
  usePopulateResolvedNodeDefinitions()

  return (
    <>
      <AnimatePresence>
        {processorTaskId && <ManualTaskProcessor key={processorTaskId} />}
      </AnimatePresence>
      <StandardLayout
        header={null}
        content={
          <InboxPanes
            list={<TasksList view={currentView} />}
            detail={<TaskPreview view={currentView} />}
            detailRoutePatterns={DETAIL_ROUTE_PATTERNS}
          />
        }
      />
    </>
  )
}
